/** "Shared with me": sites the user works on as staff + pending invitations (GET /api/user/sites/shared). Rendered on the sites list. */
import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Alert, Button, Card, Col, Row, Space, Tag, Typography, message } from 'antd';
import { useTranslation } from '../../../shared/i18n';
import { QUIET, sb } from './api';
import { StatusTag, listOf, sitePath, siteUrl, toastErr } from './common';
import { ROLE_LABELS } from './ShopStaff';

const { Text } = Typography;

export const SharedSites = ({ onChanged }) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [d, setD] = useState(null);
    const [busy, setBusy] = useState(null);
    const load = useCallback(() => { sb.get('/shared', null, QUIET).then(setD).catch(() => setD(null)); }, []);
    useEffect(() => { load(); }, [load]);

    const accept = async (i) => {
        setBusy(i.id);
        try { await sb.post('/invitations/accept', { id: i.id }); message.success(t('You now have access to {{name}}', { name: i.site_name })); load(); onChanged?.(); } catch (e) { toastErr(e); } finally { setBusy(null); }
    };
    const decline = async (i) => {
        setBusy(i.id);
        try { await sb.post(`/invitations/${i.id}/decline`); load(); } catch (e) { toastErr(e); } finally { setBusy(null); }
    };

    const inv = listOf(d?.invitations);
    const sites = listOf(d?.sites);
    if (!inv.length && !sites.length) return null;
    return (
        <div style={{ marginTop: 24 }}>
            {inv.map((i) => (
                <Alert key={i.id} type="info" showIcon style={{ marginBottom: 8 }}
                    message={t('You are invited to {{name}} as {{role}}', { name: i.site_name, role: t(ROLE_LABELS[i.role] || i.role) })}
                    action={<Space><Button size="small" type="primary" loading={busy === i.id} onClick={() => accept(i)}>{t('Accept')}</Button><Button size="small" onClick={() => decline(i)}>{t('Decline')}</Button></Space>} />
            ))}
            {sites.length > 0 && (
                <>
                    <Text strong style={{ display: 'block', margin: '12px 0' }}>{t('Shared with me')}</Text>
                    <Row gutter={[16, 16]}>
                        {sites.map((s) => (
                            <Col key={s.id} xs={24} md={12} xl={8}>
                                <Card hoverable size="small" onClick={() => navigate(sitePath(s.id))}>
                                    <Space style={{ justifyContent: 'space-between', width: '100%' }}>
                                        <Text strong ellipsis>{s.name}</Text>
                                        <Space size={4}><Tag>{t(ROLE_LABELS[s.staff_role] || s.staff_role)}</Tag><StatusTag value={s.status} /></Space>
                                    </Space>
                                    <Text type="secondary" ellipsis style={{ display: 'block' }}>{siteUrl(s).replace(/^https?:\/\//, '')}</Text>
                                </Card>
                            </Col>
                        ))}
                    </Row>
                </>
            )}
        </div>
    );
};

export default SharedSites;
